var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeeks2USuccessLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1076 48.4067H46.7652C46.7652 57.5616 39.8413 65 31.3195 65C22.7977 65 15.8737 57.5616 15.8737 48.4067H22.5314C22.5314 53.6136 26.4727 57.8477 31.3195 57.8477C36.1662 57.8477 40.1076 53.5563 40.1076 48.4067ZM61.199 14.0185V29.6391C61.199 37.3063 55.3935 43.6004 48.2033 43.6004C41.013 43.6004 35.2075 37.3636 35.2075 29.6391V25.4049H26.3129C24.8216 31.3556 19.7618 35.7614 13.7965 35.7614C6.65951 35.7614 0.800781 29.5246 0.800781 21.8002C0.800781 14.0757 6.60625 7.83891 13.7965 7.83891C19.815 7.83891 24.8749 12.2447 26.3129 18.1954H35.2608V13.9613C35.2608 6.29402 41.0663 0 48.2565 0C55.4468 0 61.199 6.35123 61.199 14.0185ZM20.0813 21.8002C20.0813 18.081 17.2585 14.9912 13.7433 14.9912C10.228 14.9912 7.40517 18.0238 7.40517 21.8002C7.40517 25.5194 10.228 28.6092 13.7433 28.6092C17.2585 28.6092 20.0813 25.5766 20.0813 21.8002ZM54.5414 14.0185C54.5414 10.2421 51.7185 7.20951 48.2033 7.20951C44.688 7.20951 41.8652 10.2421 41.8652 14.0185V29.6391C41.8652 33.4155 44.688 36.4481 48.2033 36.4481C51.7185 36.4481 54.5414 33.4155 54.5414 29.6391V14.0185Z",
    fill: "#DA192E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeeks2USuccessLogo);
export default __webpack_public_path__ + "static/media/geeks2u-success-logo.cbc15b4063df922da4fd552442e56f75.svg";
export { ForwardRef as ReactComponent };